import { useTranslation } from 'react-i18next'

export function DisplayDate({ date }: { date: Date }) {
	const { i18n } = useTranslation('common')
	const dateParts = new Intl.DateTimeFormat(i18n.language, { day: '2-digit', month: '2-digit', year: 'numeric' })
		.formatToParts(date)
		.filter(datePart => datePart.type !== 'literal')
		.map(datePart => datePart.value)

	return <time className="tracking-wider" dateTime={date.toISOString()}>{dateParts.join('/')}</time>
}
